import { render, staticRenderFns } from "./SubcontractorExpensesMaterialsEdit.vue?vue&type=template&id=01208525&"
import script from "./SubcontractorExpensesMaterialsEdit.vue?vue&type=script&lang=js&"
export * from "./SubcontractorExpensesMaterialsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports